export const FORMULA_LIST_COLDEF: any = [
  {
    field: 'name',
    header: 'formulaManagement.formulaName'
  },
  {
    field: 'targetType',
    header: 'formulaManagement.targetType'
  },
  {
    field: 'status',
    header: 'formulaManagement.status'
  },
  {
    field: 'lastUpdateDateString',
    header: 'formulaManagement.updatedDate'
  },
  {
    field: 'lastUpdatedBy',
    header: 'formulaManagement.updatedBy'
  }
];
